enum IStatus {
    BACKLOG = 'Backlog',
    TO_DO = 'To do',
    DOING = 'Doing',
    IN_REVIEW = 'In Review',
    DONE = 'Done'
} 
  
export default IStatus;